import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IOfferedServicesDataTableRowFormMeta {
    // Table Modal form fields
    id: FormInputMeta;
    label: FormInputMeta;
    
    schema: any;
}

const offeredServicesDataTableRowFormMeta = {} as IOfferedServicesDataTableRowFormMeta;

// Table modal form fields
offeredServicesDataTableRowFormMeta.id = {
    name: "id",
    type: "select",
    label: "ID",
    placeholder: "Veuillez choisir l'Id",
    validation: yup.string().required("Champ obligatoire !")
};
  
offeredServicesDataTableRowFormMeta.label = {
    name: "label",
    type: "text",
    label: "Label",
    placeholder: "Veuillez choisir le label",
    validation: yup.string().required("Champ obligatoire !")
};

offeredServicesDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(offeredServicesDataTableRowFormMeta));

export default offeredServicesDataTableRowFormMeta;